import { render, staticRenderFns } from "./RasmusChangePasswordForm.vue?vue&type=template&id=5eeba201&"
import script from "./RasmusChangePasswordForm.vue?vue&type=script&lang=ts&"
export * from "./RasmusChangePasswordForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports